export default "__VITE_ASSET__BV$7a6tU__"